import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.AUTH_SERVER_PREFIX}/employee`;
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    loadEmployeeById: (id: any) => `${RESOURCE_ENDPOINT}/loadEmployeeById/${id}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    getByDeviceId: (id: any) => `${RESOURCE_ENDPOINT}/device/${id}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    updateUserSetting: () => `${RESOURCE_ENDPOINT}/update-user-setting`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    filterDropdown: () => `${RESOURCE_ENDPOINT}/filterDropdown`,
    getEmployeeListByBlockId: () => `${RESOURCE_ENDPOINT}/getEmployeeListByBlockId`,
    searchEmployeeByMobileNumber: () => `${RESOURCE_ENDPOINT}/searchEmployeeByMobileNumber`,
};

export default class EmployeeApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();
        return HttpService.get(url, params, headers);
    };

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    };

    public loadEmployeeById = (id: any): AxiosPromise<any> => {
        const url = endpoints.loadEmployeeById(id);
        return HttpService.get(url);
    };

    public getByDeviceId = (id: any): AxiosPromise<any> => {
        const url = endpoints.getByDeviceId(id);
        return HttpService.get(url);
    };

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    };

    public updateUserSettings = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updateUserSetting();
        return HttpService.post(url, payload, params, headers);
    };

    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    };

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    };

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    };

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    };

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    };

    public filterDropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.filterDropdown();
        return HttpService.get(url, params, headers);
    };

    public getEmployeeListByBlockId = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getEmployeeListByBlockId();
        return HttpService.post(url, payload, params, headers);
    };

     public searchEmployeeByMobileNumber = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.searchEmployeeByMobileNumber();
        return HttpService.get(url, params, headers);
    };
}
